function ScanProgressRing({ verified, total, pct, size = 52 }) {
  const stroke = 5;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - Math.min(1, Math.max(0, pct)));

  return (
    <div
      className="packv2-progress-ring"
      role="progressbar"
      aria-valuenow={verified}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={`${verified} of ${total} items scanned`}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          className="packv2-progress-ring-track"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={stroke}
        />
        <circle
          className="packv2-progress-ring-fill"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className="packv2-progress-ring-label">
        {verified}/{total}
      </span>
    </div>
  );
}

export default ScanProgressRing;
